import { Box, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import { useActiveUserWorks } from "../../hooks/useActiveUserWorks";
import { useWorksFilters } from "../../hooks/useWorksFilters";
import { WorkStateEnum } from "../../store/types/work.types";
import { WorksFilters as Filters } from "../../types/WorksList.types";
import WorkCardView from "./WorkCardView";
import WorkListView from "./WorkListView";
import WorksFilters from "./WorksFilters";
import WorksTabs from "./WorksTabs";

const stateTabToEnum: Record<Filters["stateTab"], WorkStateEnum> = {
  open: WorkStateEnum.Open,
  closed: WorkStateEnum.Closed,
  solved: WorkStateEnum.Solved,
};

const WorksView: React.FC = () => {
  const [filters, setFilters] = useState<Filters>({
    search: "",
    stateTab: "open",
    dateFilter: { from: null, to: null },
    workTypes: [],
  });
  const [showFilters, setShowFilters] = useState(false);
  const isMobile = window.innerWidth <= 600;
  const [viewType, setViewType] = useState<"card" | "list">(
    isMobile ? "card" : "list"
  );

  const { data: works = [] } = useActiveUserWorks({
    state: stateTabToEnum[filters.stateTab],
  });
  const filteredWorks = useWorksFilters(works, filters);

  const handleTabChange = (_: React.SyntheticEvent, newValue: string) => {
    setFilters({
      ...filters,
      stateTab: newValue as Filters["stateTab"],
    });
  };

  return (
    <Box sx={{ maxWidth: 1200, mx: "auto", p: 2 }}>
      <Paper sx={{ mb: 3 }}>
        <Box sx={{ p: 2, pb: 0 }}>
          <WorksFilters
            filters={filters}
            onFiltersChange={setFilters}
            showFilters={showFilters}
            onToggleFilters={() => setShowFilters(!showFilters)}
          />

          <WorksTabs
            tabValue={filters.stateTab}
            onTabChange={handleTabChange}
            viewType={viewType}
            onViewTypeChange={setViewType}
          />
        </Box>
      </Paper>

      <Box sx={{ mb: 3 }}>
        {filteredWorks.length === 0 ? (
          <Paper sx={{ p: 4, textAlign: "center" }}>
            <Typography variant="h6" color="text.secondary">
              Inga ärenden hittades
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Prova att justera din sökning eller filtrera på annat sätt
            </Typography>
          </Paper>
        ) : viewType === "card" ? (
          <WorkCardView works={filteredWorks} />
        ) : (
          <WorkListView works={filteredWorks} />
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Visar {filteredWorks.length} ärenden
        </Typography>
      </Box>
    </Box>
  );
};

export default WorksView;
